export type Language = 'ru' | 'uz' | 'en';

export const LANGUAGES: readonly Language[] = ['ru', 'uz', 'en'];

const ru = {
  'app.name': 'Video Studio',
  'app.tagline': 'Генерация видео на Google Veo',

  'language.ru': 'Русский',
  'language.uz': "O'zbek",
  'language.en': 'English',

  'nav.primary': 'Основная навигация',
  'nav.dashboard': 'Проекты',
  'nav.studio': 'Студия',
  'nav.settings': 'Настройки',
  'nav.language': 'Язык интерфейса',
  'nav.signOut': 'Выйти',

  'login.tagline': 'Войдите через Google, чтобы генерировать видео',
  'login.continueWithGoogle': 'Продолжить с Google',
  'login.forbidden': 'У этого аккаунта нет доступа к Video Studio',
  'login.cancelled': 'Вход через Google был отменён',
  'login.failed': 'Не удалось завершить вход через Google. Попробуйте ещё раз',
  'login.checking': 'Проверяем сессию…',

  'dashboard.title': 'Мои видео',
  'dashboard.subtitle': 'Все генерации в одном месте',
  'dashboard.newVideo': 'Новое видео',
  'dashboard.recent': 'Все генерации',
  'dashboard.loadMore': 'Показать ещё',
  'dashboard.loadingMore': 'Загружаю…',
  'dashboard.total': 'Всего',
  'dashboard.completed': 'Готово',
  'dashboard.processing': 'В работе',
  'dashboard.failed': 'Ошибки',

  'generations.loading': 'Загружаем генерации',
  'generations.emptyTitle': 'Пока ничего не сгенерировано',
  'generations.emptyBody': 'Опишите сцену в студии — первое видео появится здесь',
  'generations.errorTitle': 'Не удалось загрузить генерации',
  'generations.errorBody': 'Проверьте соединение и попробуйте ещё раз',

  'generation.save': 'Сохранить',
  'generation.unsave': 'Убрать из сохранённых',
  'generation.delete': 'Удалить',
  'generation.regenerate': 'Сгенерировать заново',
  'generation.regenerateFailed': 'Не удалось запустить генерацию заново',
  'generation.why': 'Почему произошла ошибка',
  'failure.title': 'Почему не получилось',
  'failure.whatToDo': 'Что делать',
  'failure.detail': 'Ответ сервера',
  'failure.retryHint': 'Причина, скорее всего, временная — попробуйте запустить генерацию заново.',
  'failure.noRetryHint':
    'Повтор с тем же запросом закончится так же — сначала измените промпт или настройки.',
  'failure.referenceImage':
    'Сервис не смог получить одну из картинок, приложенных к запросу: первый или последний кадр либо фото упомянутого элемента. Файл был недоступен, отдавался слишком долго, оказался не картинкой или превысил лимит размера.',
  'failure.referenceImageAction':
    'Откройте элемент или кадр и загрузите изображение заново, затем повторите генерацию.',
  'failure.blocked':
    'Veo отказался генерировать это видео: запрос не прошёл фильтры безопасности Google. Решение принимает сторона Google, и оно относится к самому запросу, а не к сбою сервиса.',
  'failure.blockedAction':
    'Перепишите промпт: уберите упоминания насилия, откровённых сцен, реальных публичных людей и торговых марок.',
  'failure.emptyResult':
    'Veo принял задачу и завершил её, но видео не вернул. Это сбой на стороне модели, а не ошибка в вашем запросе.',
  'failure.emptyResultAction': 'Запустите генерацию заново — обычно повтор проходит.',
  'failure.rateLimit':
    'Превышена квота Google Cloud на генерацию видео. Слишком много запросов за короткое время либо исчерпан дневной лимит проекта.',
  'failure.rateLimitAction': 'Подождите несколько минут и повторите.',
  'failure.service':
    'Vertex AI ответил ошибкой или не ответил вовремя. Это временный сбой на стороне Google.',
  'failure.serviceAction': 'Подождите немного и повторите генерацию.',
  'failure.configuration':
    'Сервер не смог обратиться к Vertex AI: не настроен сервисный аккаунт Google или у него нет нужных прав. Это проблема конфигурации, а не вашего запроса.',
  'failure.configurationAction':
    'Повтор не поможет — нужна настройка доступа к Google Cloud на сервере.',
  'failure.unsupported':
    'Выбранная модель не поддерживает то, что было в запросе: например, генерацию из картинки, закрывающий кадр или такое соотношение сторон.',
  'failure.unsupportedAction':
    'Выберите другую модель или уберите неподдерживаемую настройку, затем запустите генерацию.',
  'failure.unknown':
    'Однозначно определить причину не удалось. Ниже — сообщение, которое вернул сервер.',
  'failure.unknownAction': 'Попробуйте повторить генерацию.',
  'failure.noMessage': 'Сервер не сохранил сообщение об ошибке для этой генерации.',
  'failure.shortReferenceImage': 'не удалось загрузить приложенную картинку',
  'failure.shortBlocked': 'запрос отклонён фильтрами безопасности Google',
  'failure.shortEmptyResult': 'модель завершила задачу, но не вернула видео',
  'failure.shortRateLimit': 'превышена квота Google Cloud',
  'failure.shortService': 'временный сбой на стороне Google',
  'failure.shortConfiguration': 'на сервере не настроен доступ к Google Cloud',
  'failure.shortUnsupported': 'модель не поддерживает эти настройки',
  'failure.shortUnknown': 'причину определить не удалось',
  'generation.deleteTitle': 'Удалить генерацию',
  'generation.deleteConfirm': 'Видео будет удалено безвозвратно. Продолжить?',

  'studio.title': 'Студия',
  'studio.prompt': 'Промпт',
  'studio.promptPlaceholder': 'Опишите сцену, героя, свет и настроение…',
  'studio.model': 'Модель',
  'studio.mode': 'Режим',
  'studio.aspectRatio': 'Соотношение сторон',
  'studio.duration': 'Длительность',
  'studio.stylePreset': 'Стиль',
  'studio.cameraMotion': 'Движение камеры',
  'studio.generate': 'Сгенерировать',
  'studio.generateFailed': 'Не удалось запустить генерацию',
  'studio.results': 'Результаты',
  'studio.result': 'Результат',
  'theme.toDark': 'Тёмная тема',
  'theme.toLight': 'Светлая тема',
  'studio.mentions': 'Упомянутые элементы',
  'studio.mentionHint': 'Упомяните элемент через @ — он попадёт в промпт',

  'mentions.attachedTitle': 'Что уйдёт в модель',
  'mentions.slots': 'Фото-слоты: {used} из {total}',
  'mentions.rolePhoto': 'по фото',
  'mentions.roleText': 'только описанием',
  'mentions.noPhoto': 'у элемента нет фото',
  'mentions.noSlot': 'слоты заняты',
  'mentions.unknown': 'Не найдены в библиотеке: {handles}',
  'mentions.frameDropped':
    'Загруженный первый кадр не используется: слоты заняты упомянутыми элементами',
  'mentions.modelNoReferences': 'Эта модель не принимает фото элементов — они уйдут описанием',
  'mentions.empty': 'Элементы не упомянуты',
  'mentions.category.character': 'Персонажи',
  'mentions.category.location': 'Локации',
  'mentions.category.prop': 'Реквизит',
  'mentions.category.voice': 'Голоса',
  'voices.inlinePrefix': 'Голос за кадром:',
  'mentions.category.general': 'Общие',

  'prompt.enhance': 'Улучшить промпт',
  'prompt.enrichedTitle': 'Улучшенный промпт',
  'prompt.enrichFailed': 'Не удалось улучшить промпт',
  'prompt.accept': 'Применить',
  'prompt.reject': 'Отклонить',

  'model.audio': 'Со звуком',
  'model.noAudio': 'Без звука',
  'model.imageToVideo': 'Из изображения',
  'model.lastFrame': 'Последний кадр',
  'model.editing': 'Редактирование',

  'mode.text_to_video': 'Текст → видео',
  'mode.image_to_video': 'Изображение → видео',
  'mode.reference_to_video': 'Референсы → видео',
  'mode.short.text_to_video': 'Текст',
  'mode.short.image_to_video': 'Изображение',
  'mode.short.reference_to_video': 'Референсы',

  'projectPrompts.title': 'Общие промпты проекта',
  'projectPrompts.subtitle':
    'То, что повторяется в каждом ролике: описание товара, упаковка, тон, запреты. Опишите один раз и подставляйте через @ — тогда сотый ролик получит ровно то же, что первый.',
  'projectPrompts.add': 'Добавить промпт',
  'projectPrompts.empty': 'Пока пусто. Добавьте первый — он появится в списке по @.',
  'projectPrompts.newTitle': 'Новый общий промпт',
  'projectPrompts.editTitle': 'Изменить общий промпт',
  'projectPrompts.formHint':
    'Название нужно только вам — по нему вы найдёте промпт в списке. Текст уходит в модель как есть.',
  'projectPrompts.name': 'Название',
  'projectPrompts.namePlaceholder': 'Например: Бренд Dona',
  'projectPrompts.prompt': 'Текст промпта',
  'projectPrompts.promptPlaceholder':
    'Газировка Dona в стеклянной бутылке 0,5 л, сине-белая этикетка с логотипом слева. Тон дружелюбный, без агрессивной рекламы. Никогда не показывать конкурентов.',
  'projectPrompts.promptHint':
    'Пишите фактами: что за товар, как выглядит упаковка, какой тон, чего быть не должно.',
  'projectPrompts.bothRequired': 'Заполните название и текст',
  'projectPrompts.saveFailed': 'Не удалось сохранить промпт',
  'mentions.category.project': 'Промпты проекта',

  'voices.title': 'Голоса',
  'voices.subtitle':
    'Veo придумывает нового диктора для каждого ролика. Опишите голос один раз — и выбирайте его при генерации, чтобы во всех роликах говорил один человек.',
  'voices.add': 'Добавить голос',
  'voices.empty': 'Пока ни одного голоса. Добавьте первый — он появится в выборе при генерации.',
  'voices.newTitle': 'Новый голос',
  'voices.editTitle': 'Изменить голос',
  'voices.formHint':
    'Название нужно только вам — по нему вы будете узнавать голос в списке. Описание уходит в модель.',
  'voices.name': 'Название',
  'voices.namePlaceholder': 'Например: Диктор Дона',
  'voices.prompt': 'Описание голоса',
  'voices.promptPlaceholder':
    'Женщина около 30 лет, тёплый низкий тембр, говорит спокойно и неторопливо, по-узбекски, лёгкая улыбка в голосе',
  'voices.promptHint':
    'Чем конкретнее описание, тем ближе голоса от ролика к ролику. Указывайте пол, возраст, тембр, темп речи и язык.',
  'voices.bothRequired': 'Заполните название и описание',
  'voices.saveFailed': 'Не удалось сохранить голос',
  'voices.pickerLabel': 'Голос',
  'voices.none': 'Без озвучки',
  'voices.emptyHint': 'Голоса добавляются в Настройках',
  'voices.modelHasNoAudio': 'Выбранная модель не выдаёт звук',

  'tools.title': 'Инструменты',
  'tools.extend': 'Продолжить ролик',
  'tools.extendHint':
    'Снять продолжение с последней секунды — так получаются ролики длиннее 8 секунд',
  'tools.removeObject': 'Убрать предмет',
  'tools.removeObjectHint': 'Отметить лишнее в кадре и убрать, не переснимая всё',
  'tools.insertObject': 'Добавить предмет',
  'tools.insertObjectHint': 'Поставить товар или объект в готовый кадр',
  'tools.outpaint': 'Расширить кадр',
  'tools.outpaintHint': 'Достроить края и перевести горизонтальное видео в вертикальное',
  'tools.upscale': 'Улучшить качество',
  'tools.upscaleHint': 'Поднять чёткость до 1080p или 4K',
  'tools.soon': 'Скоро',
  'tools.extendTitle': 'Продолжить ролик',
  'tools.extendBody':
    'Veo досмотрит последнюю секунду и снимет продолжение. Опишите, что должно произойти дальше — или оставьте пусто, чтобы действие просто продолжилось.',
  'tools.extendPlaceholder': 'Например: он поворачивается к камере и улыбается',
  'tools.extendCta': 'Продолжить',
  'tools.extendFailed': 'Не удалось запустить продолжение',
  'tools.extendUnsupported': 'Эта модель не умеет продолжать готовый ролик',
  'tools.extendNotReady': 'Продолжить можно только готовый ролик',
  'tools.extendLandsInStudio':
    'Продолжение появится в Студии отдельным роликом — раскадровка не изменится.',
  'tools.extendLandedInStudio': 'Продолжение запущено. Оно появится в Студии отдельным роликом.',

  'status.pending': 'В очереди',
  'status.processing': 'Генерируется',
  'status.completed': 'Готово',
  'status.failed': 'Ошибка',

  'stylePreset.cinematic': 'Кинематографично',
  'stylePreset.ugc': 'UGC',
  'stylePreset.appPromo': 'Промо приложения',
  'stylePreset.productDemo': 'Демо продукта',
  'stylePreset.characterStory': 'История персонажа',
  'stylePreset.socialAd': 'Реклама для соцсетей',

  'cameraMotion.static': 'Статика',
  'cameraMotion.zoomIn': 'Наезд',
  'cameraMotion.dollyIn': 'Долли вперёд',
  'cameraMotion.handheld': 'С рук',
  'cameraMotion.orbit': 'Орбита',
  'cameraMotion.pan': 'Панорама',

  'upload.cta': 'Загрузить изображение',
  'upload.hint': 'PNG или JPG до 10 МБ',
  'upload.progress': 'Загрузка изображения',
  'upload.remove': 'Удалить изображение',
  'upload.failed': 'Не удалось загрузить файл',
  'upload.badType': 'Поддерживаются только изображения',
  'upload.tooLarge': 'Файл больше 10 МБ',
  'upload.firstFrame': 'Первый кадр',
  'upload.lastFrame': 'Последний кадр',

  'media.title': 'Выберите медиа',
  'media.description': 'Загрузки, элементы и всё, что вы уже сгенерировали',
  'media.tabUploads': 'Загрузки',
  'media.tabElements': 'Элементы',
  'media.tabImages': 'Генерация изображений',
  'media.tabVideos': 'Видеопоколения',
  'media.tabLastFrames': 'Последние кадры',
  'media.lastFramePrevious': 'Конец предыдущего кадра',
  'cinema.saveLastFrame': 'Сохранить последний кадр',
  'cinema.saveLastFrameDone': 'Кадр скачан на компьютер и добавлен в библиотеку студии',
  'cinema.saveLastFrameFailed': 'Не удалось сохранить последний кадр',
  'cinema.saveLastFrameUnavailable': 'У этого сегмента нет сгенерированного ролика',
  'media.lastFrameNoPrevious': 'Предыдущий ролик ещё не снят',
  'media.lastFrameNoPreviousBody':
    'Сюда попадает только последний кадр ролика, который идёт перед этим. Снимите предыдущий сегмент — и его финальный кадр появится здесь',
  'media.lastFramesEmpty': 'Пока нет последних кадров',
  'media.lastFramesEmptyBody':
    'Здесь появится финальный кадр каждого готового ролика — берите его как первый кадр следующего, чтобы сцена продолжилась с того же места',
  'media.tabLiked': 'Понравилось',
  'media.uploadFile': 'Загрузить файл',
  'media.uploadHintImage': 'PNG, JPG или WebP до 10 МБ',
  'media.uploadHintVideo': 'MP4 до 10 МБ',
  'media.uploadsEmpty': 'Загрузок пока нет',
  'media.uploadsEmptyBody': 'Загрузите файл с компьютера — он останется здесь',
  'media.elementsEmpty': 'Элементов пока нет',
  'media.elementsEmptyBody': 'Персонажи, локации и реквизит с изображением появятся здесь',
  'media.imagesEmpty': 'Изображений пока нет',
  'media.imagesEmptyBody': 'Сгенерируйте фото в кино студии — они появятся здесь',
  'media.videosEmpty': 'Видео пока нет',
  'media.videosEmptyBody': 'Готовые ролики появятся здесь после генерации',
  'media.likedEmpty': 'Здесь пока пусто',
  'media.likedEmptyBody': 'Отмечайте сердечком то, что хотите держать под рукой',
  'media.select': 'Выбрать',
  'media.like': 'В понравившиеся',
  'media.unlike': 'Убрать из понравившихся',
  'media.likeFailed': 'Не удалось изменить отметку',
  'media.delete': 'Удалить',
  'media.deleteFailed': 'Не удалось удалить',
  'media.badVideoType': 'Подойдёт только MP4',
  'media.change': 'Заменить',
  'media.loadFailed': 'Не удалось загрузить библиотеку',
  'media.loadFailedBody': 'Проверьте соединение и попробуйте ещё раз',

  'element.title': 'Элементы',
  'element.subtitle': 'Персонажи, локации и реквизит для повторного использования',
  'element.new': 'Новый элемент',
  'element.newTitle': 'Создать элемент',
  'element.editTitle': 'Изменить элемент',
  'element.name': 'Название',
  'element.nameRequired': 'Укажите название',
  'element.category': 'Категория',
  'element.description': 'Описание',
  'element.descriptionPlaceholder': 'Как элемент выглядит и ведёт себя',
  'element.addImage': 'Добавить изображение',
  'element.replaceImage': 'Заменить изображение',
  'element.handlePreview': 'Упоминание',
  'element.emptyTitle': 'Элементов пока нет',
  'element.emptyBody': 'Добавьте персонажа или локацию, чтобы упоминать их через @',
  'element.loadFailed': 'Не удалось загрузить элементы',
  'element.saveFailed': 'Не удалось сохранить элемент',
  'element.deleteFailed': 'Не удалось удалить элемент',
  'element.deleteTitle': 'Удалить элемент',
  'element.deleteConfirm': 'Элемент будет удалён безвозвратно. Продолжить?',
  'element.createCta': 'Создать элемент',
  'element.create': 'Создать',
  'element.namePlaceholder': 'Введите имя',
  'element.uploadTitle': 'Загрузить медиафайл',
  'element.uploadHint': 'Перетащите файл или нажмите, чтобы загрузить',
  'element.imageRequired': 'Добавьте изображение элемента',

  'elementCategory.general': 'Общие',
  'elementCategory.character': 'Персонаж',
  'elementCategory.location': 'Локация',
  'elementCategory.prop': 'Реквизит',

  'elementFilter.heading': 'Мои элементы',
  'elementFilter.filter': 'Фильтр',
  'elementFilter.search': 'Поиск',
  'elementFilter.sortBy': 'Сортировка',
  'elementFilter.sortCreated': 'Дата создания',
  'elementFilter.sortUsed': 'Последнее использование',
  'elementFilter.sortName': 'Название',
  'elementFilter.category': 'Категория',
  'elementFilter.all': 'Все категории',
  'elementFilter.characters': 'Персонажи',
  'elementFilter.locations': 'Локации',
  'elementFilter.props': 'Реквизит',
  'elementFilter.general': 'Общие',
  'elementFilter.noMatches': 'Ничего не найдено',
  'elementFilter.noMatchesBody': 'Измените запрос или выберите другую категорию',

  'category.general': 'Общие',
  'category.character': 'Персонажи',
  'category.location': 'Локации',
  'category.prop': 'Реквизит',

  'settings.title': 'Настройки',
  'settings.account': 'Аккаунт',
  'settings.email': 'Почта',
  'settings.language': 'Язык',
  'settings.appearance': 'Внешний вид',
  'settings.appearanceHint': 'Тема подстраивается под систему, но её можно переключить',
  'settings.diagnostics': 'Диагностика',
  'settings.videoModels': 'Видеомодели',
  'settings.imageModels': 'Модели изображений',
  'settings.health.checking': 'Проверяем…',
  'settings.health.ok': 'Сервер на связи',
  'settings.health.down': 'Сервер недоступен',
  'settings.signOut': 'Выйти из аккаунта',
  'settings.version': 'Версия',

  'player.play': 'Воспроизвести',
  'player.pause': 'Пауза',
  'player.mute': 'Звук',
  'player.volume': 'Громкость',
  'player.seek': 'Перемотка',
  'player.fullscreen': 'На весь экран',
  'player.exitFullscreen': 'Выйти из полноэкранного режима',
  'player.download': 'Скачать',
  'player.region': 'Видеоплеер',

  'common.save': 'Сохранить',
  'common.cancel': 'Отмена',
  'common.delete': 'Удалить',
  'common.edit': 'Изменить',
  'common.retry': 'Повторить',
  'common.close': 'Закрыть',
  'common.loading': 'Загрузка…',
  'common.download': 'Скачать',
  'common.copy': 'Копировать',
  'common.copied': 'Скопировано',
  'common.back': 'Назад',

  'error.title': 'Что-то пошло не так',
  'error.generic': 'Не удалось выполнить действие',
  'error.network': 'Нет связи с сервером',
  'error.unauthenticated': 'Сессия истекла — войдите заново',
  'error.permissionDenied': 'Нет доступа',
  'error.notFound': 'Не найдено',
  'error.invalidArgument': 'Проверьте введённые данные',
  'error.rateLimited': 'Слишком много запросов — попробуйте позже',
  'error.internal': 'Внутренняя ошибка сервера',
  'error.unavailable': 'Сервис временно недоступен',
  'error.reload': 'Перезагрузить страницу',
  'error.updating': 'Обновление приложения',
  'error.updatingHint': 'Загружается новая версия…',
  'error.reloadNow': 'Обновить сейчас',

  'nav.cinema': 'Кино студия',
  'cinema.title': 'Кино студия',
  'cinema.modeImage': 'Image',
  'cinema.modeVideo': 'Video',
  'cinema.modeLabel': 'Режим ввода',
  'cinema.promptPlaceholder': 'Опишите, что хотите создать…',
  'cinema.generate': 'Сгенерировать',
  'cinema.heroLead': 'Создайте свой первый проект.',
  'cinema.heroAccent': 'Сгенерируйте невозможное.',
  'cinema.heroHandoff': 'Опишите кадр — и мы откроем студию с готовым промптом',
  'cinema.imageHint': 'Опишите кадр, выберите стиль — и получите фото в этом стиле',
  'cinema.imageResults': 'Сгенерированные изображения',
  'cinema.imageFailed': 'Не удалось сгенерировать изображение',
  'cinema.imageDelete': 'Удалить изображение',
  'cinema.imageDeleteFailed': 'Не удалось удалить изображение',
  'cinema.imageDownload': 'Открыть изображение',
  'cinema.pickModel': 'Выберите модель',
  'cinema.pickAspect': 'Соотношение',
  'cinema.pickDuration': 'Длительность',
  'cinema.pickStyle': 'Стиль',
  'cinema.pickCamera': 'Камера',
  'cinema.upTo': 'до',
  'cinema.secondsShort': 'с',
  'cinema.segments': 'Сегменты',
  'cinema.segmentAdd': 'Добавить сегмент',
  'cinema.segmentRemove': 'Убрать сегмент',
  'cinema.generating': 'генерация…',
  'cinema.segmentFailed': 'ошибка',
  'cinema.segmentRetry': 'повтор',
  'cinema.segmentWhy': 'подробнее',
  'cinema.slotChange': 'изменить',
  'cinema.slotHint': 'Клик — выбрать фото | Ctrl+Клик — загрузить видео',
  'cinema.slotFirstFrame': 'первый кадр',
  'cinema.slotLastFrame': 'последний кадр',
  'cinema.slotSource': 'Откуда взять фото',
  'cinema.slotFromDevice': 'Выбрать с компьютера',
  'cinema.slotFromLibrary': 'Выбрать из библиотеки',
  'cinema.libraryTitle': 'Библиотека изображений',
  'cinema.libraryDescription': 'Изображения, которые вы сгенерировали в этом проекте',
  'cinema.libraryEmpty': 'Пока ничего не сгенерировано — создайте фото в режиме Image',
  'cinema.libraryLoadFailed': 'Не удалось загрузить библиотеку изображений',
  'cinema.librarySelect': 'Выбрать',
  'cinema.libraryPickFailed': 'Не удалось подставить изображение в слот',
  'cinema.clearSegment': 'Очистить сегмент',
  'cinema.clearSlot': 'Убрать изображение',
  'cinema.player': 'Плеер кино студии',
  'cinema.timeline': 'Таймлиния сегментов',
  'cinema.empty': 'Сегменты появятся здесь после генерации',
  'cinema.back': 'Предыдущий сегмент',
  'cinema.forward': 'Следующий сегмент',
  'cinema.volumeMax': 'Громко',
  'cinema.volumeMedium': 'Средний',
  'cinema.volumeMute': 'Без звука',
  'cinema.export': 'Сохранить',
  'cinema.exporting': 'Сборка',
  'cinema.exportFailed': 'Не удалось собрать видео',
  'cinema.exportSilent': 'Видео собрано, но браузер не отдал звуковую дорожку',
  'cinema.uploadFailed': 'Не удалось загрузить файл',
  'cinema.uploadBadVideo': 'Для сегмента подойдёт только MP4',
  'cinema.loadFailed': 'Не удалось загрузить раскадровку',

  'settings.mcp.title': 'Подключение к Claude (MCP)',
  'settings.mcp.subtitle':
    'Дайте Claude доступ к вашей студии: он сможет генерировать видео и работать с элементами прямо из диалога. Ключ входит в адрес подключения, поэтому храните ссылку как пароль.',
  'settings.mcp.enabled': 'Сервер MCP включён',
  'settings.mcp.disabled': 'Сервер MCP выключен',
  'settings.mcp.disabledHint':
    'На этом сервере MCP отключён (MCP_ENABLED=false) — ключ создать можно, но подключение работать не будет.',
  'settings.mcp.noKey': 'Ключ ещё не создан',
  'settings.mcp.create': 'Создать ключ',
  'settings.mcp.rotate': 'Создать заново',
  'settings.mcp.revoke': 'Отозвать',
  'settings.mcp.rotateHint':
    'Ссылку видно только один раз. Потеряли — создайте заново: старый ключ сразу перестанет работать.',
  'settings.mcp.onceWarning': 'Скопируйте ссылку сейчас — второй раз она не покажется',
  'settings.mcp.urlLabel': 'Адрес подключения',
  'settings.mcp.copy': 'Копировать',
  'settings.mcp.copied': 'Скопировано',
  'settings.mcp.copyFailed': 'Браузер не дал скопировать — выделите ссылку вручную',
  'settings.mcp.created': 'Создан',
  'settings.mcp.lastUsed': 'Последнее использование',
  'settings.mcp.neverUsed': 'Ещё ни разу не использован',
  'settings.mcp.failed': 'Не удалось выполнить действие с ключом',
  'settings.mcp.loadFailed': 'Не удалось загрузить состояние ключа',
  'settings.mcp.step1Title': 'Откройте настройки Claude',
  'settings.mcp.step1Body': 'В приложении или на claude.ai перейдите в Настройки → Коннекторы.',
  'settings.mcp.step2Title': 'Добавьте свой коннектор',
  'settings.mcp.step2Body': 'Назовите его Video Studio и вставьте адрес подключения выше.',
  'settings.mcp.step3Title': 'Подключитесь',
  'settings.mcp.step3Body':
    'Нажмите Добавить → Подключить. Готово — попросите Claude сгенерировать видео.',
} as const;

export type TranslationKey = keyof typeof ru;

type Dictionary = Record<TranslationKey, string>;

const uz: Dictionary = {
  'app.name': 'Video Studio',
  'app.tagline': 'Google Veo asosida video generatsiyasi',

  'language.ru': 'Русский',
  'language.uz': "O'zbek",
  'language.en': 'English',

  'nav.primary': 'Asosiy navigatsiya',
  'nav.dashboard': 'Loyihalar',
  'nav.studio': 'Studiya',
  'nav.settings': 'Sozlamalar',
  'nav.language': 'Interfeys tili',
  'nav.signOut': 'Chiqish',

  'login.tagline': 'Video yaratish uchun Google orqali kiring',
  'login.continueWithGoogle': 'Google bilan davom etish',
  'login.forbidden': 'Bu akkauntda Video Studio-ga ruxsat yo‘q',
  'login.cancelled': 'Google orqali kirish bekor qilindi',
  'login.failed': 'Google orqali kirishni yakunlab bo‘lmadi. Qayta urinib ko‘ring',
  'login.checking': 'Sessiya tekshirilmoqda…',

  'dashboard.title': 'Mening videolarim',
  'dashboard.subtitle': 'Barcha generatsiyalar bir joyda',
  'dashboard.newVideo': 'Yangi video',
  'dashboard.recent': 'Barcha generatsiyalar',
  'dashboard.loadMore': 'Yana ko‘rsatish',
  'dashboard.loadingMore': 'Yuklanmoqda…',
  'dashboard.total': 'Jami',
  'dashboard.completed': 'Tayyor',
  'dashboard.processing': 'Jarayonda',
  'dashboard.failed': 'Xatolar',

  'generations.loading': 'Generatsiyalar yuklanmoqda',
  'generations.emptyTitle': 'Hozircha hech narsa yaratilmagan',
  'generations.emptyBody': 'Studiyada sahnani tasvirlang — birinchi video shu yerda paydo bo‘ladi',
  'generations.errorTitle': 'Generatsiyalarni yuklab bo‘lmadi',
  'generations.errorBody': 'Aloqani tekshiring va qayta urinib ko‘ring',

  'generation.save': 'Saqlash',
  'generation.unsave': 'Saqlanganlardan olib tashlash',
  'generation.delete': 'O‘chirish',
  'generation.regenerate': 'Qaytadan generatsiya qilish',
  'generation.regenerateFailed': 'Qaytadan generatsiyani boshlab bo‘lmadi',
  'generation.why': 'Xatolik nega yuz berdi',
  'failure.title': 'Nega chiqmadi',
  'failure.whatToDo': 'Nima qilish kerak',
  'failure.detail': 'Server javobi',
  'failure.retryHint': 'Sabab vaqtinchalik bo‘lishi mumkin — qaytadan generatsiya qilib ko‘ring.',
  'failure.noRetryHint':
    'Xuddi shu so‘rov bilan qayta urinish ham shunday tugaydi — avval promptni yoki sozlamalarni o‘zgartiring.',
  'failure.referenceImage':
    'Xizmat so‘rovga biriktirilgan rasmlardan birini ololmadi: birinchi yoki oxirgi kadr, yoki eslatilgan elementning surati. Fayl mavjud emas edi, juda sekin ochildi, rasm emas edi yoki hajm chegarasidan oshdi.',
  'failure.referenceImageAction':
    'Elementni yoki kadrni oching va rasmni qaytadan yuklang, so‘ng generatsiyani takrorlang.',
  'failure.blocked':
    'Veo bu videoni yaratishdan bosh tortdi: so‘rov Google xavfsizlik filtridan o‘tmadi. Qaror Google tomonidan qabul qilinadi va u so‘rovning o‘ziga tegishli.',
  'failure.blockedAction':
    'Promptni qayta yozing: zo‘ravonlik, ochiq sahnalar, real mashhur shaxslar va brendlar haqidagi eslatmalarni olib tashlang.',
  'failure.emptyResult':
    'Veo vazifani qabul qildi va tugatdi, lekin video qaytarmadi. Bu model tomonidagi nosozlik, so‘rovingizdagi xato emas.',
  'failure.emptyResultAction': 'Qaytadan generatsiya qiling — odatda takror urinish o‘tadi.',
  'failure.rateLimit':
    'Google Cloud’ning video generatsiya kvotasi oshib ketdi. Qisqa vaqtda juda ko‘p so‘rov yuborilgan yoki loyihaning kunlik chegarasi tugagan.',
  'failure.rateLimitAction': 'Bir necha daqiqa kutib, qayta urinib ko‘ring.',
  'failure.service':
    'Vertex AI xatolik qaytardi yoki o‘z vaqtida javob bermadi. Bu Google tomonidagi vaqtinchalik nosozlik.',
  'failure.serviceAction': 'Biroz kutib, generatsiyani takrorlang.',
  'failure.configuration':
    'Server Vertex AI’ga ulana olmadi: Google xizmat akkaunti sozlanmagan yoki uning huquqlari yetarli emas. Bu sozlama muammosi, so‘rovingiz emas.',
  'failure.configurationAction':
    'Takrorlash yordam bermaydi — serverda Google Cloud kirish huquqini sozlash kerak.',
  'failure.unsupported':
    'Tanlangan model so‘rovdagi imkoniyatni qo‘llab-quvvatlamaydi: masalan, rasmdan video, yakuniy kadr yoki shu nisbat.',
  'failure.unsupportedAction':
    'Boshqa modelni tanlang yoki qo‘llab-quvvatlanmaydigan sozlamani olib tashlang, so‘ng generatsiyani boshlang.',
  'failure.unknown': 'Sababni aniq belgilab bo‘lmadi. Quyida server qaytargan xabar keltirilgan.',
  'failure.unknownAction': 'Generatsiyani qaytadan urinib ko‘ring.',
  'failure.noMessage': 'Server bu generatsiya uchun xatolik xabarini saqlamagan.',
  'failure.shortReferenceImage': 'biriktirilgan rasmni yuklab bo‘lmadi',
  'failure.shortBlocked': 'so‘rov Google xavfsizlik filtrlaridan o‘tmadi',
  'failure.shortEmptyResult': 'model ishni tugatdi, lekin video qaytarmadi',
  'failure.shortRateLimit': 'Google Cloud kvotasi oshib ketdi',
  'failure.shortService': 'Google tomonida vaqtinchalik nosozlik',
  'failure.shortConfiguration': 'serverda Google Cloud kirish sozlanmagan',
  'failure.shortUnsupported': 'model bu sozlamalarni qo‘llab-quvvatlamaydi',
  'failure.shortUnknown': 'sababni aniqlab bo‘lmadi',
  'generation.deleteTitle': 'Generatsiyani o‘chirish',
  'generation.deleteConfirm': 'Video butunlay o‘chiriladi. Davom etamizmi?',

  'studio.title': 'Studiya',
  'studio.prompt': 'Prompt',
  'studio.promptPlaceholder': 'Sahna, qahramon, yorug‘lik va kayfiyatni tasvirlang…',
  'studio.model': 'Model',
  'studio.mode': 'Rejim',
  'studio.aspectRatio': 'Tomonlar nisbati',
  'studio.duration': 'Davomiylik',
  'studio.stylePreset': 'Uslub',
  'studio.cameraMotion': 'Kamera harakati',
  'studio.generate': 'Yaratish',
  'studio.generateFailed': 'Generatsiyani boshlab bo‘lmadi',
  'studio.results': 'Natijalar',
  'studio.result': 'Natija',
  'theme.toDark': 'Tungi mavzu',
  'theme.toLight': 'Kunduzgi mavzu',
  'studio.mentions': 'Eslangan elementlar',
  'studio.mentionHint': 'Elementni @ bilan eslang — u promptga tushadi',

  'mentions.attachedTitle': 'Modelga nima ketadi',
  'mentions.slots': 'Foto slotlar: {used} / {total}',
  'mentions.rolePhoto': 'foto orqali',
  'mentions.roleText': 'faqat tavsif bilan',
  'mentions.noPhoto': 'elementda foto yo‘q',
  'mentions.noSlot': 'slotlar band',
  'mentions.unknown': 'Kutubxonada topilmadi: {handles}',
  'mentions.frameDropped':
    'Yuklangan birinchi kadr ishlatilmaydi: slotlarni eslangan elementlar egalladi',
  'mentions.modelNoReferences':
    'Bu model element fotolarini qabul qilmaydi — tavsif sifatida ketadi',
  'mentions.empty': 'Element eslanmagan',
  'mentions.category.character': 'Personajlar',
  'mentions.category.location': 'Lokatsiyalar',
  'mentions.category.prop': 'Rekvizit',
  'mentions.category.voice': 'Ovozlar',
  'voices.inlinePrefix': 'Kadr ortidagi ovoz (voice-over):',
  'mentions.category.general': 'Umumiy',

  'prompt.enhance': 'Promptni yaxshilash',
  'prompt.enrichedTitle': 'Yaxshilangan prompt',
  'prompt.enrichFailed': 'Promptni yaxshilab bo‘lmadi',
  'prompt.accept': 'Qo‘llash',
  'prompt.reject': 'Rad etish',

  'model.audio': 'Ovoz bilan',
  'model.noAudio': 'Ovozsiz',
  'model.imageToVideo': 'Rasmdan',
  'model.lastFrame': 'Oxirgi kadr',
  'model.editing': 'Tahrirlash',

  'mode.text_to_video': 'Matn → video',
  'mode.image_to_video': 'Rasm → video',
  'mode.reference_to_video': 'Namunalar → video',
  'mode.short.text_to_video': 'Matn',
  'mode.short.image_to_video': 'Rasm',
  'mode.short.reference_to_video': 'Namunalar',

  'projectPrompts.title': 'Loyihaning umumiy promptlari',
  'projectPrompts.subtitle':
    'Har bir rolikda takrorlanadigan narsalar: mahsulot ta’rifi, qadoq, ohang, taqiqlar. Bir marta yozing va @ orqali qo‘shing — yuzinchi rolik ham birinchisi bilan bir xil ma’lumot oladi.',
  'projectPrompts.add': 'Prompt qo‘shish',
  'projectPrompts.empty': 'Hozircha bo‘sh. Birinchisini qo‘shing — u @ ro‘yxatida chiqadi.',
  'projectPrompts.newTitle': 'Yangi umumiy prompt',
  'projectPrompts.editTitle': 'Umumiy promptni o‘zgartirish',
  'projectPrompts.formHint':
    'Nom faqat sizga kerak — ro‘yxatdan shu bo‘yicha topasiz. Matn modelga o‘zgarishsiz ketadi.',
  'projectPrompts.name': 'Nomi',
  'projectPrompts.namePlaceholder': 'Masalan: Dona brendi',
  'projectPrompts.prompt': 'Prompt matni',
  'projectPrompts.promptPlaceholder':
    'Dona gazli ichimligi, 0,5 l shisha idishda, chapda logotipli ko‘k-oq yorliq. Ohang do‘stona. Raqobatchilarni hech qachon ko‘rsatmaslik.',
  'projectPrompts.promptHint':
    'Faktlar bilan yozing: mahsulot nima, qadoq qanday, ohang qanday, nima bo‘lmasligi kerak.',
  'projectPrompts.bothRequired': 'Nom va matnni to‘ldiring',
  'projectPrompts.saveFailed': 'Promptni saqlab bo‘lmadi',
  'mentions.category.project': 'Loyiha promptlari',

  'voices.title': 'Ovozlar',
  'voices.subtitle':
    'Veo har bir rolik uchun yangi diktor o‘ylab topadi. Ovozni bir marta ta’riflang va generatsiyada tanlang — shunda hamma rolikda bitta odam gapiradi.',
  'voices.add': 'Ovoz qo‘shish',
  'voices.empty':
    'Hozircha ovozlar yo‘q. Birinchisini qo‘shing — u generatsiyadagi ro‘yxatda paydo bo‘ladi.',
  'voices.newTitle': 'Yangi ovoz',
  'voices.editTitle': 'Ovozni o‘zgartirish',
  'voices.formHint':
    'Nom faqat sizga kerak — ro‘yxatdan shu bo‘yicha tanaysiz. Ta’rif esa modelga ketadi.',
  'voices.name': 'Nomi',
  'voices.namePlaceholder': 'Masalan: Dona diktori',
  'voices.prompt': 'Ovoz ta’rifi',
  'voices.promptPlaceholder':
    '30 yoshlardagi ayol, iliq past tembr, xotirjam va shoshmasdan gapiradi, o‘zbekcha',
  'voices.promptHint':
    'Ta’rif qanchalik aniq bo‘lsa, ovoz roliklar orasida shunchalik yaqin chiqadi. Jinsi, yoshi, tembri, nutq sur’ati va tilini yozing.',
  'voices.bothRequired': 'Nom va ta’rifni to‘ldiring',
  'voices.saveFailed': 'Ovozni saqlab bo‘lmadi',
  'voices.pickerLabel': 'Ovoz',
  'voices.none': 'Ovozsiz',
  'voices.emptyHint': 'Ovozlar Sozlamalarda qo‘shiladi',
  'voices.modelHasNoAudio': 'Tanlangan model ovoz chiqarmaydi',

  'tools.title': 'Asboblar',
  'tools.extend': 'Rolikni davom ettirish',
  'tools.extendHint': 'Oxirgi soniyadan davomini olish — 8 soniyadan uzun roliklar shunday chiqadi',
  'tools.removeObject': 'Buyumni olib tashlash',
  'tools.removeObjectHint': 'Kadrdagi ortiqchani belgilab olib tashlang, hammasini qayta olmasdan',
  'tools.insertObject': 'Buyum qo‘shish',
  'tools.insertObjectHint': 'Tayyor kadrga mahsulot yoki obyektni qo‘ying',
  'tools.outpaint': 'Kadrni kengaytirish',
  'tools.outpaintHint': 'Chekkalarni to‘ldirib, gorizontal videoni vertikalga aylantiring',
  'tools.upscale': 'Sifatni yaxshilash',
  'tools.upscaleHint': 'Aniqlikni 1080p yoki 4K gacha ko‘taring',
  'tools.soon': 'Tez orada',
  'tools.extendTitle': 'Rolikni davom ettirish',
  'tools.extendBody':
    'Veo oxirgi soniyani ko‘rib, davomini oladi. Keyin nima bo‘lishini yozing — yoki bo‘sh qoldiring, shunda harakat shunchaki davom etadi.',
  'tools.extendPlaceholder': 'Masalan: u kameraga o‘girilib jilmayadi',
  'tools.extendCta': 'Davom ettirish',
  'tools.extendFailed': 'Davomini boshlab bo‘lmadi',
  'tools.extendUnsupported': 'Bu model tayyor rolikni davom ettira olmaydi',
  'tools.extendNotReady': 'Faqat tayyor rolikni davom ettirish mumkin',
  'tools.extendLandsInStudio':
    'Davomi Studiyada alohida rolik sifatida paydo bo‘ladi — raskadrovka o‘zgarmaydi.',
  'tools.extendLandedInStudio': 'Davomi boshlandi. U Studiyada alohida rolik bo‘lib chiqadi.',

  'status.pending': 'Navbatda',
  'status.processing': 'Yaratilmoqda',
  'status.completed': 'Tayyor',
  'status.failed': 'Xato',

  'stylePreset.cinematic': 'Kinematografik',
  'stylePreset.ugc': 'UGC',
  'stylePreset.appPromo': 'Ilova promosi',
  'stylePreset.productDemo': 'Mahsulot demosi',
  'stylePreset.characterStory': 'Qahramon hikoyasi',
  'stylePreset.socialAd': 'Ijtimoiy tarmoq reklamasi',

  'cameraMotion.static': 'Statik',
  'cameraMotion.zoomIn': 'Yaqinlashish',
  'cameraMotion.dollyIn': 'Dolli oldinga',
  'cameraMotion.handheld': 'Qo‘lda',
  'cameraMotion.orbit': 'Orbita',
  'cameraMotion.pan': 'Panorama',

  'upload.cta': 'Rasm yuklash',
  'upload.hint': 'PNG yoki JPG, 10 MB gacha',
  'upload.progress': 'Rasm yuklanmoqda',
  'upload.remove': 'Rasmni o‘chirish',
  'upload.failed': 'Faylni yuklab bo‘lmadi',
  'upload.badType': 'Faqat rasmlar qo‘llab-quvvatlanadi',
  'upload.tooLarge': 'Fayl 10 MB dan katta',
  'upload.firstFrame': 'Birinchi kadr',
  'upload.lastFrame': 'Oxirgi kadr',

  'media.title': 'Media tanlang',
  'media.description': 'Yuklamalar, elementlar va siz yaratgan hamma narsa',
  'media.tabUploads': 'Yuklamalar',
  'media.tabElements': 'Elementlar',
  'media.tabImages': 'Rasm generatsiyasi',
  'media.tabVideos': 'Video generatsiyalar',
  'media.tabLastFrames': 'Oxirgi kadrlar',
  'media.lastFramePrevious': 'Oldingi kadrning oxiri',
  'cinema.saveLastFrame': 'Oxirgi kadrni saqlash',
  'cinema.saveLastFrameDone': 'Kadr kompyuterga yuklandi va studiya kutubxonasiga qo‘shildi',
  'cinema.saveLastFrameFailed': 'Oxirgi kadrni saqlab bo‘lmadi',
  'cinema.saveLastFrameUnavailable': 'Bu segmentda yaratilgan rolik yo‘q',
  'media.lastFrameNoPrevious': 'Oldingi rolik hali olinmagan',
  'media.lastFrameNoPreviousBody':
    'Bu yerga faqat shu kadrdan oldingi rolikning oxirgi kadri tushadi. Oldingi segmentni oling — yakuniy kadri shu yerda paydo bo‘ladi',
  'media.lastFramesEmpty': 'Hozircha oxirgi kadrlar yo‘q',
  'media.lastFramesEmptyBody':
    'Bu yerda har bir tayyor rolikning yakuniy kadri chiqadi — uni keyingi rolikning birinchi kadri sifatida oling, shunda sahna xuddi shu joydan davom etadi',
  'media.tabLiked': 'Yoqqanlar',
  'media.uploadFile': 'Fayl yuklash',
  'media.uploadHintImage': 'PNG, JPG yoki WebP, 10 MB gacha',
  'media.uploadHintVideo': 'MP4, 10 MB gacha',
  'media.uploadsEmpty': 'Hozircha yuklamalar yo‘q',
  'media.uploadsEmptyBody': 'Kompyuterdan fayl yuklang — u shu yerda qoladi',
  'media.elementsEmpty': 'Hozircha elementlar yo‘q',
  'media.elementsEmptyBody': 'Rasmi bor personaj, lokatsiya va rekvizit shu yerda ko‘rinadi',
  'media.imagesEmpty': 'Hozircha rasmlar yo‘q',
  'media.imagesEmptyBody': 'Kino studiyada foto yarating — ular shu yerda paydo bo‘ladi',
  'media.videosEmpty': 'Hozircha videolar yo‘q',
  'media.videosEmptyBody': 'Tayyor roliklar generatsiyadan keyin shu yerda bo‘ladi',
  'media.likedEmpty': 'Bu yer hozircha bo‘sh',
  'media.likedEmptyBody': 'Kerakli narsalarni yurakcha bilan belgilang',
  'media.select': 'Tanlash',
  'media.like': 'Yoqqanlarga qo‘shish',
  'media.unlike': 'Yoqqanlardan olib tashlash',
  'media.likeFailed': 'Belgini o‘zgartirib bo‘lmadi',
  'media.delete': 'O‘chirish',
  'media.deleteFailed': 'O‘chirib bo‘lmadi',
  'media.badVideoType': 'Faqat MP4 mos keladi',
  'media.change': 'Almashtirish',
  'media.loadFailed': 'Kutubxonani yuklab bo‘lmadi',
  'media.loadFailedBody': 'Aloqani tekshiring va qayta urinib ko‘ring',

  'element.title': 'Elementlar',
  'element.subtitle': 'Qayta ishlatiladigan qahramonlar, joylar va rekvizit',
  'element.new': 'Yangi element',
  'element.newTitle': 'Element yaratish',
  'element.editTitle': 'Elementni tahrirlash',
  'element.name': 'Nomi',
  'element.nameRequired': 'Nomini kiriting',
  'element.category': 'Kategoriya',
  'element.description': 'Tavsif',
  'element.descriptionPlaceholder': 'Element qanday ko‘rinadi va harakat qiladi',
  'element.addImage': 'Rasm qo‘shish',
  'element.replaceImage': 'Rasmni almashtirish',
  'element.handlePreview': 'Eslash',
  'element.emptyTitle': 'Hozircha elementlar yo‘q',
  'element.emptyBody': 'Qahramon yoki joy qo‘shing va ularni @ orqali eslang',
  'element.loadFailed': 'Elementlarni yuklab bo‘lmadi',
  'element.saveFailed': 'Elementni saqlab bo‘lmadi',
  'element.deleteFailed': 'Elementni o‘chirib bo‘lmadi',
  'element.deleteTitle': 'Elementni o‘chirish',
  'element.deleteConfirm': 'Element butunlay o‘chiriladi. Davom etamizmi?',
  'element.createCta': 'Element yaratish',
  'element.create': 'Yaratish',
  'element.namePlaceholder': 'Nomini kiriting',
  'element.uploadTitle': 'Media fayl yuklash',
  'element.uploadHint': 'Faylni tashlang yoki yuklash uchun bosing',
  'element.imageRequired': 'Element uchun rasm qo‘shing',

  'elementCategory.general': 'Umumiy',
  'elementCategory.character': 'Qahramon',
  'elementCategory.location': 'Lokatsiya',
  'elementCategory.prop': 'Rekvizit',

  'elementFilter.heading': 'Mening elementlarim',
  'elementFilter.filter': 'Filtr',
  'elementFilter.search': 'Qidiruv',
  'elementFilter.sortBy': 'Saralash',
  'elementFilter.sortCreated': 'Yaratilgan sana',
  'elementFilter.sortUsed': 'Oxirgi ishlatilgan',
  'elementFilter.sortName': 'Nomi',
  'elementFilter.category': 'Kategoriya',
  'elementFilter.all': 'Barcha kategoriyalar',
  'elementFilter.characters': 'Qahramonlar',
  'elementFilter.locations': 'Lokatsiyalar',
  'elementFilter.props': 'Rekvizit',
  'elementFilter.general': 'Umumiy',
  'elementFilter.noMatches': 'Hech narsa topilmadi',
  'elementFilter.noMatchesBody': 'So‘rovni o‘zgartiring yoki boshqa kategoriyani tanlang',

  'category.general': 'Umumiy',
  'category.character': 'Qahramonlar',
  'category.location': 'Joylar',
  'category.prop': 'Rekvizit',

  'settings.title': 'Sozlamalar',
  'settings.account': 'Akkaunt',
  'settings.email': 'Pochta',
  'settings.language': 'Til',
  'settings.appearance': 'Tashqi ko‘rinish',
  'settings.appearanceHint': 'Mavzu tizimga moslashadi, lekin uni almashtirish mumkin',
  'settings.diagnostics': 'Diagnostika',
  'settings.videoModels': 'Video modellar',
  'settings.imageModels': 'Rasm modellari',
  'settings.health.checking': 'Tekshirilmoqda…',
  'settings.health.ok': 'Server aloqada',
  'settings.health.down': 'Server mavjud emas',
  'settings.signOut': 'Akkauntdan chiqish',
  'settings.version': 'Versiya',

  'player.play': 'Ijro etish',
  'player.pause': 'Pauza',
  'player.mute': 'Ovoz',
  'player.volume': 'Ovoz balandligi',
  'player.seek': 'O‘tkazish',
  'player.fullscreen': 'To‘liq ekran',
  'player.exitFullscreen': 'To‘liq ekrandan chiqish',
  'player.download': 'Yuklab olish',
  'player.region': 'Video pleyer',

  'common.save': 'Saqlash',
  'common.cancel': 'Bekor qilish',
  'common.delete': 'O‘chirish',
  'common.edit': 'Tahrirlash',
  'common.retry': 'Qayta urinish',
  'common.close': 'Yopish',
  'common.loading': 'Yuklanmoqda…',
  'common.download': 'Yuklab olish',
  'common.copy': 'Nusxalash',
  'common.copied': 'Nusxalandi',
  'common.back': 'Orqaga',

  'error.title': 'Nimadir noto‘g‘ri ketdi',
  'error.generic': 'Amalni bajarib bo‘lmadi',
  'error.network': 'Server bilan aloqa yo‘q',
  'error.unauthenticated': 'Sessiya tugadi — qayta kiring',
  'error.permissionDenied': 'Ruxsat yo‘q',
  'error.notFound': 'Topilmadi',
  'error.invalidArgument': 'Kiritilgan ma’lumotlarni tekshiring',
  'error.rateLimited': 'So‘rovlar juda ko‘p — birozdan keyin urinib ko‘ring',
  'error.internal': 'Serverning ichki xatosi',
  'error.unavailable': 'Xizmat vaqtincha mavjud emas',
  'error.reload': 'Sahifani yangilash',
  'error.updating': 'Ilova yangilanmoqda',
  'error.updatingHint': 'Yangi versiya yuklanmoqda…',
  'error.reloadNow': 'Hozir yangilash',

  'nav.cinema': 'Kino studiya',
  'cinema.title': 'Kino studiya',
  'cinema.modeImage': 'Image',
  'cinema.modeVideo': 'Video',
  'cinema.modeLabel': 'Kiritish rejimi',
  'cinema.promptPlaceholder': 'Nima yaratmoqchi ekaningizni yozing…',
  'cinema.generate': 'Generatsiya',
  'cinema.heroLead': 'Birinchi loyihangizni yarating.',
  'cinema.heroAccent': 'Imkonsizni generatsiya qiling.',
  'cinema.heroHandoff': 'Kadrni tasvirlang — studiya tayyor prompt bilan ochiladi',
  'cinema.imageHint': 'Kadrni tasvirlang, uslubni tanlang — shu uslubda foto olasiz',
  'cinema.imageResults': 'Yaratilgan rasmlar',
  'cinema.imageFailed': 'Rasmni yaratib bo‘lmadi',
  'cinema.imageDelete': 'Rasmni o‘chirish',
  'cinema.imageDeleteFailed': 'Rasmni o‘chirib bo‘lmadi',
  'cinema.imageDownload': 'Rasmni ochish',
  'cinema.pickModel': 'Modelni tanlang',
  'cinema.pickAspect': 'Nisbat',
  'cinema.pickDuration': 'Davomiyligi',
  'cinema.pickStyle': 'Uslub',
  'cinema.pickCamera': 'Kamera',
  'cinema.upTo': 'gacha',
  'cinema.secondsShort': 's',
  'cinema.segments': 'Segmentlar',
  'cinema.segmentAdd': 'Segment qo‘shish',
  'cinema.segmentRemove': 'Segmentni olib tashlash',
  'cinema.generating': 'generatsiya…',
  'cinema.segmentFailed': 'xato',
  'cinema.segmentRetry': 'qayta',
  'cinema.segmentWhy': 'batafsil',
  'cinema.slotChange': 'o‘zgartirish',
  'cinema.slotHint': 'Bosish — foto tanlash | Ctrl+Bosish — video yuklash',
  'cinema.slotFirstFrame': 'birinchi kadr',
  'cinema.slotLastFrame': 'oxirgi kadr',
  'cinema.slotSource': 'Foto qayerdan olinsin',
  'cinema.slotFromDevice': 'Kompyuterdan tanlash',
  'cinema.slotFromLibrary': 'Kutubxonadan tanlash',
  'cinema.libraryTitle': 'Rasmlar kutubxonasi',
  'cinema.libraryDescription': 'Shu loyihada o‘zingiz yaratgan rasmlar',
  'cinema.libraryEmpty': 'Hozircha hech narsa yaratilmagan — Image rejimida foto yarating',
  'cinema.libraryLoadFailed': 'Rasmlar kutubxonasini yuklab bo‘lmadi',
  'cinema.librarySelect': 'Tanlash',
  'cinema.libraryPickFailed': 'Rasmni slotga qo‘yib bo‘lmadi',
  'cinema.clearSegment': 'Segmentni tozalash',
  'cinema.clearSlot': 'Rasmni olib tashlash',
  'cinema.player': 'Kino studiya pleyeri',
  'cinema.timeline': 'Segmentlar vaqt chizig‘i',
  'cinema.empty': 'Segmentlar generatsiyadan keyin shu yerda paydo bo‘ladi',
  'cinema.back': 'Oldingi segment',
  'cinema.forward': 'Keyingi segment',
  'cinema.volumeMax': 'Baland',
  'cinema.volumeMedium': 'O‘rtacha',
  'cinema.volumeMute': 'Ovozsiz',
  'cinema.export': 'Saqlash',
  'cinema.exporting': 'Yig‘ilmoqda',
  'cinema.exportFailed': 'Videoni yig‘ib bo‘lmadi',
  'cinema.exportSilent': 'Video yig‘ildi, lekin brauzer ovoz yo‘lini bermadi',
  'cinema.uploadFailed': 'Faylni yuklab bo‘lmadi',
  'cinema.uploadBadVideo': 'Segment uchun faqat MP4 mos keladi',
  'cinema.loadFailed': 'Kadrlar ketma-ketligini yuklab bo‘lmadi',

  'settings.mcp.title': 'Claude bilan ulanish (MCP)',
  'settings.mcp.subtitle':
    'Claude’ga studiyangizga kirish huquqini bering: u suhbatning o‘zidan video generatsiya qila oladi. Kalit ulanish manzili ichida bo‘lgani uchun havolani parol kabi saqlang.',
  'settings.mcp.enabled': 'MCP serveri yoqilgan',
  'settings.mcp.disabled': 'MCP serveri o‘chirilgan',
  'settings.mcp.disabledHint':
    'Bu serverda MCP o‘chirilgan (MCP_ENABLED=false) — kalit yaratish mumkin, lekin ulanish ishlamaydi.',
  'settings.mcp.noKey': 'Kalit hali yaratilmagan',
  'settings.mcp.create': 'Kalit yaratish',
  'settings.mcp.rotate': 'Qayta yaratish',
  'settings.mcp.revoke': 'Bekor qilish',
  'settings.mcp.rotateHint':
    'Havola faqat bir marta ko‘rsatiladi. Yo‘qotsangiz qayta yarating — eski kalit darhol ishlamay qoladi.',
  'settings.mcp.onceWarning': 'Havolani hozir nusxalang — ikkinchi marta ko‘rsatilmaydi',
  'settings.mcp.urlLabel': 'Ulanish manzili',
  'settings.mcp.copy': 'Nusxalash',
  'settings.mcp.copied': 'Nusxalandi',
  'settings.mcp.copyFailed': 'Brauzer nusxalashga ruxsat bermadi — havolani qo‘lda belgilang',
  'settings.mcp.created': 'Yaratilgan',
  'settings.mcp.lastUsed': 'Oxirgi ishlatilgan',
  'settings.mcp.neverUsed': 'Hali ishlatilmagan',
  'settings.mcp.failed': 'Kalit bilan amalni bajarib bo‘lmadi',
  'settings.mcp.loadFailed': 'Kalit holatini yuklab bo‘lmadi',
  'settings.mcp.step1Title': 'Claude sozlamalarini oching',
  'settings.mcp.step1Body': 'Ilovada yoki claude.ai’da Sozlamalar → Konnektorlar bo‘limiga o‘ting.',
  'settings.mcp.step2Title': 'O‘z konnektoringizni qo‘shing',
  'settings.mcp.step2Body': 'Uni Video Studio deb nomlang va yuqoridagi manzilni joylashtiring.',
  'settings.mcp.step3Title': 'Ulaning',
  'settings.mcp.step3Body':
    'Qo‘shish → Ulanish tugmasini bosing. Tayyor — Claude’dan video so‘rang.',
};

const en: Dictionary = {
  'app.name': 'Video Studio',
  'app.tagline': 'Video generation powered by Google Veo',

  'language.ru': 'Русский',
  'language.uz': "O'zbek",
  'language.en': 'English',

  'nav.primary': 'Primary navigation',
  'nav.dashboard': 'Projects',
  'nav.studio': 'Studio',
  'nav.settings': 'Settings',
  'nav.language': 'Interface language',
  'nav.signOut': 'Sign out',

  'login.tagline': 'Sign in with Google to start generating video',
  'login.continueWithGoogle': 'Continue with Google',
  'login.forbidden': 'This account does not have access to Video Studio',
  'login.cancelled': 'Google sign-in was cancelled',
  'login.failed': 'Google sign-in could not be completed. Please try again',
  'login.checking': 'Checking your session…',

  'dashboard.title': 'My videos',
  'dashboard.subtitle': 'Every generation in one place',
  'dashboard.newVideo': 'New video',
  'dashboard.recent': 'All generations',
  'dashboard.loadMore': 'Show more',
  'dashboard.loadingMore': 'Loading…',
  'dashboard.total': 'Total',
  'dashboard.completed': 'Ready',
  'dashboard.processing': 'In progress',
  'dashboard.failed': 'Failed',

  'generations.loading': 'Loading generations',
  'generations.emptyTitle': 'Nothing generated yet',
  'generations.emptyBody': 'Describe a scene in the studio — your first video will show up here',
  'generations.errorTitle': 'Could not load your generations',
  'generations.errorBody': 'Check your connection and try again',

  'generation.save': 'Save',
  'generation.unsave': 'Remove from saved',
  'generation.delete': 'Delete',
  'generation.regenerate': 'Generate again',
  'generation.regenerateFailed': 'Could not start the generation again',
  'generation.why': 'Why this failed',
  'failure.title': 'Why this failed',
  'failure.whatToDo': 'What to do',
  'failure.detail': 'Server response',
  'failure.retryHint': 'The cause is most likely temporary — try generating it again.',
  'failure.noRetryHint':
    'Running the same request again will end the same way — change the prompt or the settings first.',
  'failure.referenceImage':
    'The service could not fetch one of the images attached to the request: the first or last frame, or the photo of a mentioned element. The file was unreachable, took too long, was not an image, or exceeded the size limit.',
  'failure.referenceImageAction':
    'Open the element or the frame, upload the image again, then retry the generation.',
  'failure.blocked':
    'Veo refused to generate this video: the request did not pass Google’s safety filters. That decision is made on Google’s side and is about the request itself, not a service fault.',
  'failure.blockedAction':
    'Rewrite the prompt: drop references to violence, explicit scenes, real public figures and trademarks.',
  'failure.emptyResult':
    'Veo accepted the job and finished it, but returned no video. This is a fault on the model’s side, not an error in your request.',
  'failure.emptyResultAction': 'Generate it again — a second attempt usually goes through.',
  'failure.rateLimit':
    'The Google Cloud quota for video generation was exceeded: too many requests in a short window, or the project’s daily limit is spent.',
  'failure.rateLimitAction': 'Wait a few minutes and try again.',
  'failure.service':
    'Vertex AI returned an error or did not answer in time. This is a temporary fault on Google’s side.',
  'failure.serviceAction': 'Wait a little and run the generation again.',
  'failure.configuration':
    'The server could not reach Vertex AI: the Google service account is not configured, or it lacks the required permissions. This is a configuration problem, not your request.',
  'failure.configurationAction':
    'Retrying will not help — Google Cloud access has to be set up on the server.',
  'failure.unsupported':
    'The chosen model does not support something the request asked for: image-to-video, a closing frame, or that aspect ratio.',
  'failure.unsupportedAction':
    'Pick a different model or drop the unsupported setting, then run the generation.',
  'failure.unknown':
    'The cause could not be identified with confidence. The message the server returned is below.',
  'failure.unknownAction': 'Try running the generation again.',
  'failure.noMessage': 'The server stored no error message for this generation.',
  'failure.shortReferenceImage': 'an attached image could not be downloaded',
  'failure.shortBlocked': 'the request was refused by Google safety filters',
  'failure.shortEmptyResult': 'the model finished without returning a video',
  'failure.shortRateLimit': 'the Google Cloud quota was exceeded',
  'failure.shortService': 'a temporary failure on Google side',
  'failure.shortConfiguration': 'Google Cloud access is not configured on the server',
  'failure.shortUnsupported': 'the model does not support these settings',
  'failure.shortUnknown': 'the cause could not be identified',
  'generation.deleteTitle': 'Delete generation',
  'generation.deleteConfirm': 'This video will be deleted permanently. Continue?',

  'studio.title': 'Studio',
  'studio.prompt': 'Prompt',
  'studio.promptPlaceholder': 'Describe the scene, character, lighting and mood…',
  'studio.model': 'Model',
  'studio.mode': 'Mode',
  'studio.aspectRatio': 'Aspect ratio',
  'studio.duration': 'Duration',
  'studio.stylePreset': 'Style',
  'studio.cameraMotion': 'Camera motion',
  'studio.generate': 'Generate',
  'studio.generateFailed': 'Could not start the generation',
  'studio.results': 'Results',
  'studio.result': 'Result',
  'theme.toDark': 'Dark theme',
  'theme.toLight': 'Light theme',
  'studio.mentions': 'Mentioned elements',
  'studio.mentionHint': 'Mention an element with @ to pull it into the prompt',

  'mentions.attachedTitle': 'What the model receives',
  'mentions.slots': 'Photo slots: {used} of {total}',
  'mentions.rolePhoto': 'as a photo',
  'mentions.roleText': 'as a description only',
  'mentions.noPhoto': 'the element has no photo',
  'mentions.noSlot': 'all slots taken',
  'mentions.unknown': 'Not in your library: {handles}',
  'mentions.frameDropped':
    'The uploaded first frame is not used: the mentioned elements took the slots',
  'mentions.modelNoReferences':
    'This model takes no element photos — they travel as descriptions instead',
  'mentions.empty': 'No elements mentioned',
  'mentions.category.character': 'Characters',
  'mentions.category.location': 'Locations',
  'mentions.category.prop': 'Props',
  'mentions.category.voice': 'Voices',
  'voices.inlinePrefix': 'Voice-over:',
  'mentions.category.general': 'General',

  'prompt.enhance': 'Enhance prompt',
  'prompt.enrichedTitle': 'Enhanced prompt',
  'prompt.enrichFailed': 'Could not enhance the prompt',
  'prompt.accept': 'Apply',
  'prompt.reject': 'Discard',

  'model.audio': 'With audio',
  'model.noAudio': 'No audio',
  'model.imageToVideo': 'Image to video',
  'model.lastFrame': 'Last frame',
  'model.editing': 'Editing',

  'mode.text_to_video': 'Text → video',
  'mode.image_to_video': 'Image → video',
  'mode.reference_to_video': 'References → video',
  'mode.short.text_to_video': 'Text',
  'mode.short.image_to_video': 'Image',
  'mode.short.reference_to_video': 'References',

  'projectPrompts.title': 'Project prompts',
  'projectPrompts.subtitle':
    'What repeats in every clip: the product, the packaging, the tone, what must never appear. Write it once and paste it with @, so the hundredth clip is told exactly what the first was.',
  'projectPrompts.add': 'Add a prompt',
  'projectPrompts.empty': 'Nothing yet. Add one and it appears in the @ list.',
  'projectPrompts.newTitle': 'New project prompt',
  'projectPrompts.editTitle': 'Edit project prompt',
  'projectPrompts.formHint':
    'The name is only for you — it is how you find it in the list. The text reaches the model unchanged.',
  'projectPrompts.name': 'Name',
  'projectPrompts.namePlaceholder': 'For example: Dona brand',
  'projectPrompts.prompt': 'Prompt text',
  'projectPrompts.promptPlaceholder':
    'Dona sparkling drink in a 0.5 l glass bottle, blue and white label with the logo on the left. Friendly tone, no hard selling. Never show competitors.',
  'projectPrompts.promptHint':
    'Write facts: what the product is, how the packaging looks, the tone, what must not appear.',
  'projectPrompts.bothRequired': 'Fill in both the name and the text',
  'projectPrompts.saveFailed': 'Could not save the prompt',
  'mentions.category.project': 'Project prompts',

  'voices.title': 'Voices',
  'voices.subtitle':
    'Veo casts a new narrator for every clip. Describe a voice once and pick it when generating, so the same person speaks across the whole campaign.',
  'voices.add': 'Add a voice',
  'voices.empty': 'No voices yet. Add one and it appears in the picker when you generate.',
  'voices.newTitle': 'New voice',
  'voices.editTitle': 'Edit voice',
  'voices.formHint':
    'The name is only for you — it is how you recognise the voice in the list. The description is what reaches the model.',
  'voices.name': 'Name',
  'voices.namePlaceholder': 'For example: Dona narrator',
  'voices.prompt': 'Voice description',
  'voices.promptPlaceholder':
    'Woman around 30, warm low register, speaks calmly and unhurried, in Uzbek, a slight smile in the voice',
  'voices.promptHint':
    'The more specific the description, the closer the voice stays from clip to clip. Give gender, age, timbre, pace and language.',
  'voices.bothRequired': 'Fill in both the name and the description',
  'voices.saveFailed': 'Could not save the voice',
  'voices.pickerLabel': 'Voice',
  'voices.none': 'No narration',
  'voices.emptyHint': 'Voices are added in Settings',
  'voices.modelHasNoAudio': 'The selected model produces no audio',

  'tools.title': 'Tools',
  'tools.extend': 'Continue the clip',
  'tools.extendHint': 'Shoot on from the last second — this is how a clip gets past 8 seconds',
  'tools.removeObject': 'Remove an object',
  'tools.removeObjectHint': 'Mark what does not belong and take it out, without reshooting',
  'tools.insertObject': 'Add an object',
  'tools.insertObjectHint': 'Place a product or object into a finished shot',
  'tools.outpaint': 'Extend the frame',
  'tools.outpaintHint': 'Fill in the edges and turn a landscape clip into a vertical one',
  'tools.upscale': 'Improve quality',
  'tools.upscaleHint': 'Raise the resolution to 1080p or 4K',
  'tools.soon': 'Soon',
  'tools.extendTitle': 'Continue the clip',
  'tools.extendBody':
    'Veo reads the last second and shoots on from it. Describe what happens next — or leave it empty and the action simply carries on.',
  'tools.extendPlaceholder': 'For example: he turns to the camera and smiles',
  'tools.extendCta': 'Continue',
  'tools.extendFailed': 'Could not start the continuation',
  'tools.extendUnsupported': 'This model cannot continue a finished clip',
  'tools.extendNotReady': 'Only a finished clip can be continued',
  'tools.extendLandsInStudio':
    'The continuation appears in the Studio as its own clip — the storyboard is unchanged.',
  'tools.extendLandedInStudio':
    'Continuation started. It will appear in the Studio as its own clip.',

  'status.pending': 'Queued',
  'status.processing': 'Generating',
  'status.completed': 'Ready',
  'status.failed': 'Failed',

  'stylePreset.cinematic': 'Cinematic',
  'stylePreset.ugc': 'UGC',
  'stylePreset.appPromo': 'App promo',
  'stylePreset.productDemo': 'Product demo',
  'stylePreset.characterStory': 'Character story',
  'stylePreset.socialAd': 'Social ad',

  'cameraMotion.static': 'Static',
  'cameraMotion.zoomIn': 'Zoom in',
  'cameraMotion.dollyIn': 'Dolly in',
  'cameraMotion.handheld': 'Handheld',
  'cameraMotion.orbit': 'Orbit',
  'cameraMotion.pan': 'Pan',

  'upload.cta': 'Upload an image',
  'upload.hint': 'PNG or JPG up to 10 MB',
  'upload.progress': 'Uploading image',
  'upload.remove': 'Remove image',
  'upload.failed': 'Could not upload the file',
  'upload.badType': 'Only images are supported',
  'upload.tooLarge': 'The file is larger than 10 MB',
  'upload.firstFrame': 'First frame',
  'upload.lastFrame': 'Last frame',

  'media.title': 'Choose media',
  'media.description': 'Uploads, elements and everything you have generated',
  'media.tabUploads': 'Uploads',
  'media.tabElements': 'Elements',
  'media.tabImages': 'Image generations',
  'media.tabVideos': 'Video generations',
  'media.tabLastFrames': 'Last frames',
  'media.lastFramePrevious': 'End of the previous shot',
  'cinema.saveLastFrame': 'Save the last frame',
  'cinema.saveLastFrameDone':
    'The frame was downloaded to your computer and added to the studio library',
  'cinema.saveLastFrameFailed': 'Could not save the last frame',
  'cinema.saveLastFrameUnavailable': 'This segment has no generated clip',
  'media.lastFrameNoPrevious': 'The previous shot has not been filmed yet',
  'media.lastFrameNoPreviousBody':
    'Only the closing frame of the shot before this one lands here. Generate the previous segment and its final frame appears',
  'media.lastFramesEmpty': 'No last frames yet',
  'media.lastFramesEmptyBody':
    'The closing frame of every finished clip lands here — take one as the opening frame of the next and the scene carries on from the same place',
  'media.tabLiked': 'Liked',
  'media.uploadFile': 'Upload a file',
  'media.uploadHintImage': 'PNG, JPG or WebP up to 10 MB',
  'media.uploadHintVideo': 'MP4 up to 10 MB',
  'media.uploadsEmpty': 'No uploads yet',
  'media.uploadsEmptyBody': 'Upload a file from your computer — it stays here',
  'media.elementsEmpty': 'No elements yet',
  'media.elementsEmptyBody': 'Characters, locations and props with an image show up here',
  'media.imagesEmpty': 'No images yet',
  'media.imagesEmptyBody': 'Generate a photo in Cinema Studio and it lands here',
  'media.videosEmpty': 'No videos yet',
  'media.videosEmptyBody': 'Finished clips show up here once a generation completes',
  'media.likedEmpty': 'Nothing here yet',
  'media.likedEmptyBody': 'Heart the things you want within reach',
  'media.select': 'Select',
  'media.like': 'Add to liked',
  'media.unlike': 'Remove from liked',
  'media.likeFailed': 'Could not change the like',
  'media.delete': 'Delete',
  'media.deleteFailed': 'Could not delete it',
  'media.badVideoType': 'Only MP4 works here',
  'media.change': 'Replace',
  'media.loadFailed': 'Could not load the library',
  'media.loadFailedBody': 'Check the connection and try again',

  'element.title': 'Elements',
  'element.subtitle': 'Reusable characters, locations and props',
  'element.new': 'New element',
  'element.newTitle': 'Create an element',
  'element.editTitle': 'Edit element',
  'element.name': 'Name',
  'element.nameRequired': 'Enter a name',
  'element.category': 'Category',
  'element.description': 'Description',
  'element.descriptionPlaceholder': 'How the element looks and behaves',
  'element.addImage': 'Add an image',
  'element.replaceImage': 'Replace image',
  'element.handlePreview': 'Mention',
  'element.emptyTitle': 'No elements yet',
  'element.emptyBody': 'Add a character or a location to mention it with @',
  'element.loadFailed': 'Could not load your elements',
  'element.saveFailed': 'Could not save the element',
  'element.deleteFailed': 'Could not delete the element',
  'element.deleteTitle': 'Delete element',
  'element.deleteConfirm': 'This element will be deleted permanently. Continue?',
  'element.createCta': 'Create element',
  'element.create': 'Create',
  'element.namePlaceholder': 'Enter a name',
  'element.uploadTitle': 'Upload media',
  'element.uploadHint': 'Drop a file here or click to upload',
  'element.imageRequired': 'Add an image for the element',

  'elementCategory.general': 'General',
  'elementCategory.character': 'Character',
  'elementCategory.location': 'Location',
  'elementCategory.prop': 'Prop',

  'elementFilter.heading': 'My elements',
  'elementFilter.filter': 'Filter',
  'elementFilter.search': 'Search',
  'elementFilter.sortBy': 'Sort by',
  'elementFilter.sortCreated': 'Last created',
  'elementFilter.sortUsed': 'Last used',
  'elementFilter.sortName': 'Name',
  'elementFilter.category': 'Category',
  'elementFilter.all': 'All categories',
  'elementFilter.characters': 'Characters',
  'elementFilter.locations': 'Locations',
  'elementFilter.props': 'Props',
  'elementFilter.general': 'General',
  'elementFilter.noMatches': 'Nothing found',
  'elementFilter.noMatchesBody': 'Change the search or pick another category',

  'category.general': 'General',
  'category.character': 'Characters',
  'category.location': 'Locations',
  'category.prop': 'Props',

  'settings.title': 'Settings',
  'settings.account': 'Account',
  'settings.email': 'Email',
  'settings.language': 'Language',
  'settings.appearance': 'Appearance',
  'settings.appearanceHint': 'The theme follows your system, but you can switch it',
  'settings.diagnostics': 'Diagnostics',
  'settings.videoModels': 'Video models',
  'settings.imageModels': 'Image models',
  'settings.health.checking': 'Checking…',
  'settings.health.ok': 'API reachable',
  'settings.health.down': 'API unreachable',
  'settings.signOut': 'Sign out',
  'settings.version': 'Version',

  'player.play': 'Play',
  'player.pause': 'Pause',
  'player.mute': 'Sound',
  'player.volume': 'Volume',
  'player.seek': 'Seek',
  'player.fullscreen': 'Fullscreen',
  'player.exitFullscreen': 'Exit fullscreen',
  'player.download': 'Download',
  'player.region': 'Video player',

  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.retry': 'Retry',
  'common.close': 'Close',
  'common.loading': 'Loading…',
  'common.download': 'Download',
  'common.copy': 'Copy',
  'common.copied': 'Copied',
  'common.back': 'Back',

  'error.title': 'Something went wrong',
  'error.generic': 'The action could not be completed',
  'error.network': 'No connection to the server',
  'error.unauthenticated': 'Your session expired — sign in again',
  'error.permissionDenied': 'Access denied',
  'error.notFound': 'Not found',
  'error.invalidArgument': 'Check the values you entered',
  'error.rateLimited': 'Too many requests — try again later',
  'error.internal': 'Internal server error',
  'error.unavailable': 'The service is temporarily unavailable',
  'error.reload': 'Reload the page',
  'error.updating': 'Updating the app',
  'error.updatingHint': 'A new version is loading…',
  'error.reloadNow': 'Reload now',

  'nav.cinema': 'Cinema Studio',
  'cinema.title': 'Cinema Studio',
  'cinema.modeImage': 'Image',
  'cinema.modeVideo': 'Video',
  'cinema.modeLabel': 'Input mode',
  'cinema.promptPlaceholder': 'Describe what you want to create…',
  'cinema.generate': 'Generate',
  'cinema.heroLead': 'Create your first project.',
  'cinema.heroAccent': 'Generate the impossible.',
  'cinema.heroHandoff': 'Describe the shot — the studio opens with your prompt ready',
  'cinema.imageHint': 'Describe the shot, pick a style — the photo comes back in that style',
  'cinema.imageResults': 'Generated images',
  'cinema.imageFailed': 'Could not generate the image',
  'cinema.imageDelete': 'Delete the image',
  'cinema.imageDeleteFailed': 'Could not delete the image',
  'cinema.imageDownload': 'Open the image',
  'cinema.pickModel': 'Choose a model',
  'cinema.pickAspect': 'Aspect ratio',
  'cinema.pickDuration': 'Duration',
  'cinema.pickStyle': 'Style',
  'cinema.pickCamera': 'Camera',
  'cinema.upTo': 'up to',
  'cinema.secondsShort': 's',
  'cinema.segments': 'Segments',
  'cinema.segmentAdd': 'Add a segment',
  'cinema.segmentRemove': 'Remove a segment',
  'cinema.generating': 'generating…',
  'cinema.segmentFailed': 'failed',
  'cinema.segmentRetry': 'retry',
  'cinema.segmentWhy': 'details',
  'cinema.slotChange': 'change',
  'cinema.slotHint': 'Click to pick a photo | Ctrl+Click to upload a video',
  'cinema.slotFirstFrame': 'first frame',
  'cinema.slotLastFrame': 'last frame',
  'cinema.slotSource': 'Where the photo comes from',
  'cinema.slotFromDevice': 'Pick from your computer',
  'cinema.slotFromLibrary': 'Pick from the library',
  'cinema.libraryTitle': 'Image library',
  'cinema.libraryDescription': 'The images you generated in this project',
  'cinema.libraryEmpty': 'Nothing generated yet — create a photo in Image mode',
  'cinema.libraryLoadFailed': 'The image library could not be loaded',
  'cinema.librarySelect': 'Pick',
  'cinema.libraryPickFailed': 'The image could not be placed in the slot',
  'cinema.clearSegment': 'Clear the segment',
  'cinema.clearSlot': 'Remove the image',
  'cinema.player': 'Cinema Studio player',
  'cinema.timeline': 'Segment timeline',
  'cinema.empty': 'Segments will appear here once they are generated',
  'cinema.back': 'Previous segment',
  'cinema.forward': 'Next segment',
  'cinema.volumeMax': 'Loud',
  'cinema.volumeMedium': 'Medium',
  'cinema.volumeMute': 'Muted',
  'cinema.export': 'Save',
  'cinema.exporting': 'Stitching',
  'cinema.exportFailed': 'The video could not be stitched',
  'cinema.exportSilent': 'The video was stitched, but the browser gave us no audio track',
  'cinema.uploadFailed': 'The file could not be uploaded',
  'cinema.uploadBadVideo': 'A segment accepts MP4 only',
  'cinema.loadFailed': 'The storyboard could not be loaded',

  'settings.mcp.title': 'Connect to Claude (MCP)',
  'settings.mcp.subtitle':
    'Give Claude access to your studio so it can generate video and work with elements straight from a conversation. The key is part of the connector address, so treat the link like a password.',
  'settings.mcp.enabled': 'MCP server enabled',
  'settings.mcp.disabled': 'MCP server disabled',
  'settings.mcp.disabledHint':
    'MCP is switched off on this server (MCP_ENABLED=false) — you can still create a key, but the connection will not work.',
  'settings.mcp.noKey': 'No key yet',
  'settings.mcp.create': 'Create a key',
  'settings.mcp.rotate': 'Create a new one',
  'settings.mcp.revoke': 'Revoke',
  'settings.mcp.rotateHint':
    'The link is shown once. Lost it? Create a new one — the old key stops working immediately.',
  'settings.mcp.onceWarning': 'Copy the link now — it will not be shown again',
  'settings.mcp.urlLabel': 'Connector address',
  'settings.mcp.copy': 'Copy',
  'settings.mcp.copied': 'Copied',
  'settings.mcp.copyFailed': 'The browser blocked copying — select the link manually',
  'settings.mcp.created': 'Created',
  'settings.mcp.lastUsed': 'Last used',
  'settings.mcp.neverUsed': 'Never used yet',
  'settings.mcp.failed': 'The key operation could not be completed',
  'settings.mcp.loadFailed': 'The key status could not be loaded',
  'settings.mcp.step1Title': 'Open Claude settings',
  'settings.mcp.step1Body': 'Launch the app or open claude.ai and go to Settings → Connectors.',
  'settings.mcp.step2Title': 'Add a custom connector',
  'settings.mcp.step2Body': 'Name it Video Studio and paste the connector address above.',
  'settings.mcp.step3Title': 'Connect',
  'settings.mcp.step3Body': 'Click Add → Connect. Done — now ask Claude to generate a video.',
};

export const translations: Record<Language, Dictionary> = { ru, uz, en };

export function isLanguage(value: unknown): value is Language {
  return value === 'ru' || value === 'uz' || value === 'en';
}
